import { createSlice } from '@reduxjs/toolkit';


export const sessionDB = createSlice({
    name: 'session',
    initialState: {
        leftMenu: [],
        home: '',
        url: '',
        header: '',
        footer: false,
        baseUrl: '',
        application: '',
        name: '',
        contactUs: false,
        subscriptionPopUp: false,
        guest: {
            isAuthorized: false,
            email: ""
        }
    },
    reducers: {
        setSubscriptionPopUp: (state, action) => {
            var guest = state.guest;
            return {
                ...state,
                subscriptionPopUp: action.payload
            }
        },
        setGuest: (state, action) => {
            var guest = state.guest;
            return {
                ...state,
                guest: action.payload
            }
        },
        setContactUs: (state, action) => {
            return {
                ...state,
                contactUs: action.payload
            }
        },
        setLeftMenu: (state, action) => {
            return {
                ...state,
                leftMenu: action.payload
            }
        },
        setHome: (state, action) => {
            return {
                ...state,
                home: action.payload
            }
        },
        setUrl: (state, action) => {
            return {
                ...state,
                url: action.payload
            }
        },
        setHeader: (state, action) => {
            return {
                ...state,
                header: action.payload
            }
        },
        setFooter: (state, action) => {
            return {
                ...state,
                footer: action.payload
            }
        },
        setSetBaseUrl: (state, action) => {
            return {
                ...state,
                baseUrl: action.payload
            }
        },
        setApplication: (state, action) => {
            return {
                ...state,
                application: action.payload
            }
        },
        setName: (state, action) => {
            return {
                ...state,
                name: action.payload
            }
        }
    }
})

export const { setLeftMenu, setHome, setGuest, setUrl, setFooter, setName, setHeader, setSetBaseUrl, setApplication, setContactUs, setSubscriptionPopUp } = sessionDB.actions

export default sessionDB.reducer